import * as ng from 'angular';

ng.module('e360').directive('filterBar', filterBarDirective);

filterBarDirective.$inject = ['$window', '$timeout'];
export function filterBarDirective($window:ng.IWindowService, $timeout:ng.ITimeoutService) {
   return {
      restrict: 'A',
      link: filterBarLink
   };

   function filterBarLink(scope, element:ng.IAugmentedJQuery) {
      let collapseWidth:number;
      let primaryItem = element.find('li.primary');

      // using timeout to give template chance to compile/render for accurate width
      $timeout(() => checkWidth());

      ng.element($window).bind('resize', onWindowResize);

      element.find('li.toggle button').bind('click', toggleExpanded);
      element.find('li.hide-expanded span').bind('click', toggleExpanded);

      function checkWidth() {
         var e = element[0];

         // when .primary is empty, trigger collapse when content overflows
         if (primaryItem.is(':empty')) {
            if (e.scrollWidth > e.clientWidth) {
               collapseWidth = e.clientWidth;
               element.addClass('collapsed');
            }
         // when .primary has content, trigger collapse when min width reached
         } else if (primaryItem.width() < 150) {
            collapseWidth = e.clientWidth;
            element.addClass('collapsed');
         }
      }

      function toggleExpanded() {
         if (element.hasClass('expanded')) {
            element.removeClass('expanded');
         } else {
            element.addClass('expanded');
         }
      }

      function onWindowResize() {
         // when collapsed, use previous collapse size to decide when to restore
         if (collapseWidth && element[0].clientWidth > collapseWidth) {
            element.removeClass('collapsed');
            collapseWidth = undefined;
         }

         checkWidth();
      }
   }
}
